import { render, staticRenderFns } from "./InvitationView.vue?vue&type=template&id=092d61cf&scoped=true"
import script from "./InvitationView.vue?vue&type=script&lang=js"
export * from "./InvitationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d61cf",
  null
  
)

export default component.exports